<ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '0px', fullScreenBackdrop: true }"></ngx-loading>

<form #missionForm="ngForm">
  <div class="row">
    <div class="col-md-6">
      <div class="form-group">
        <label class="control-label">Label</label>
        <input class="form-control modern-input" type="text" name="label" [(ngModel)]="mission.label" required autocomplete="off" />
      </div>
    </div>

    <div class="col-md-6">
      <div class="poi-selector-header">
        <label class="control-label">Veuillez choisir les P.O.I</label>
        <i (click)="importModal.show()" class="fa fa-upload poi-import-icon" title="Importer P.O.I"></i>
      </div>
      <div class="poi-selector-wrapper">
        <select class="form-control modern-select" (change)="onChange($event.target.value)" *ngIf="items.length > 0">
          <option [ngValue]="null" disabled selected>Choisir un P.O.I</option>
          <option *ngFor="let g of items; let i = index" [value]="g.id">{{g.name}}</option>
        </select>
        <span class="select-icon"><i class="fa fa-chevron-down"></i></span>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-md-12 table-wrapper-scroll-y my-custom-scrollbar">
      <table class="table table-bordered table-striped modern-table">
        <thead>
          <tr>
            <th class="col-md-2">Ordre</th>
            <th>Libellé</th>
            <th class="col-md-2">Action</th>
          </tr>
        </thead>
        <tbody cdkDropList (cdkDropListDropped)="drop($event)">
          <tr *ngFor="let t of selectedPoi; let i = index" cdkDrag>
            <td>
              <div class="order-buttons">
                <button class="btn btn-sm btn-icon" [disabled]="i === 0" (click)="moveRowUp(i)" title="Monter">
                  <i class="fa fa-arrow-up"></i>
                </button>
                <button class="btn btn-sm btn-icon" [disabled]="i === selectedPoi.length - 1" (click)="moveRowDown(i)" title="Descendre">
                  <i class="fa fa-arrow-down"></i>
                </button>
                <span class="order-number">{{i + 1}}</span>
              </div>
            </td>
            <td>{{t.name}}</td>
            <td>
              <button class="btn btn-sm btn-icon btn-delete" title="Supprimer" type="button" (click)="onDelete(selectedPoi, i)">
                <i class="fa fa-trash-o"></i>
              </button>
            </td>
          </tr>

          <tr *ngIf="selectedPoi.length <= 0">
            <td colspan="3">
              <div class="alert alert-warning modern-alert" style="text-align: center">
                <h4><i class="fa fa-info-circle"></i> Information</h4>
                Veuillez ajouter un point d'intérêt
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div class="box-footer">
    <button *ngIf="mode == 'ADD'" class="btn btn-primary pull-right modern-btn" [disabled]="!missionForm.form.valid || selectedPoi.length < 2 || found" (click)="onSaveMission()">
      <i class="fa fa-spinner fa-spin" *ngIf="loading"></i> Valider
    </button>
    <button *ngIf="mode == 'UPDATE'" class="btn btn-primary pull-right modern-btn" [disabled]="!missionForm.form.valid || selectedPoi.length < 2 || found" (click)="onUpdateMission()">
      <i class="fa fa-spinner fa-spin" *ngIf="loading"></i> Enregistrer
    </button>
  </div>
</form>

<!-- Import Modal -->
<div bsModal #importModal="bs-modal" class="modal" tabindex="-1" role="dialog">
  <div class="modal-dialog modal-lg">
    <div class="modal-content modern-modal">
      <div class="modal-header">
        <h4 class="modal-title"><i class="fa fa-cogs"></i> Importer la liste des POI</h4>
        <button type="button" class="close" (click)="importModal.hide()">×</button>
      </div>
      <div class="modal-body">
        <div class="form-group import-file-group">
          <div class="col-sm-8">
            <input style="display: none" type="file" name="file" (input)="onFileChanged($event)" accept=".xlsx" #fileInput>
            <button (click)="fileInput.click()" class="btn btn-light modern-btn">Choisir un fichier</button>
            <button (click)="onUpload()" class="btn btn-success modern-btn" [disabled]="!selectedFile">Importer</button>
            <a class="pull-left" href="{{templateDownloadLocation}}TemplateExcel/{{template}}" download>
              <button type="button" class="btn btn-success modern-btn"><i class="fa fa-download"></i> Télécharger Template</button>
            </a>
          </div>
          <div class="col-lg-4 file-status">
            <span *ngIf="selectedFile && !messageError">{{selectedFile.name}}</span>
            <span *ngIf="messageError" class="error-text">{{messageError}}</span>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-default modern-btn" (click)="importModal.hide()">Fermer</button>
      </div>
    </div>
  </div>
</div>
